import React from 'react'

import { PRIMARY_DARKER } from '../../utils/constants'

const TranslateIcon = () => (
  <svg
    display="block"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.74453 14.9132H3.21641C2.2895 14.9132 1.53809 14.1632 1.53809 13.2381V4.4314C1.53809 3.5063 2.2895 2.75635 3.21641 2.75635H12.0403C12.9672 2.75635 13.7187 3.5063 13.7187 4.4314V6.37628"
      stroke={PRIMARY_DARKER}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.6917 7.80469H12.8678C11.9409 7.80469 11.1895 8.55464 11.1895 9.47974V18.2865C11.1895 19.2116 11.9409 19.9615 12.8678 19.9615H13.9766V22.1765L16.5056 19.9615H21.6917C22.6187 19.9615 23.3701 19.2116 23.3701 18.2865V9.47978C23.3701 8.55464 22.6187 7.80469 21.6917 7.80469Z"
      stroke={PRIMARY_DARKER}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.87207 6.47949H11.3491"
      stroke={PRIMARY_DARKER}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.61035 5.04443V6.47952"
      stroke={PRIMARY_DARKER}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.76738 6.62305C9.76738 6.62305 9.19224 10.6413 4.20752 12.5547"
      stroke={PRIMARY_DARKER}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.02881 8.63232C6.7957 9.87609 8.42529 11.5982 10.9176 12.5549"
      stroke={PRIMARY_DARKER}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6279 17.1291L17.2748 10.6265L19.9217 17.1291"
      stroke={PRIMARY_DARKER}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4878 15.0171H18.9957"
      stroke={PRIMARY_DARKER}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default TranslateIcon
